// *************************
// *****  In-page Nav  *****
// *************************
import { viewport } from '../../js/global';
import { watchViewport } from 'tornis';
import { breakPoint } from '../../js/config';

import './in-page-nav.scss';

const navs = [];
let isMobile = true,
    resizeRequested = false,
    scrollUpdateRequested = false;

class InPageNav {

    constructor(el, getIndex) {
        this.el = el;
        this.index = getIndex;
        this.menuContentExpanded = false;
        this.activeMenuIndex = 0;
        // find elements
        this.menu = el.querySelector('.in-page-nav--menu');
        this.menuToggle = this.menu.querySelector('.in-page-nav--menu--toggle');
        this.menuToggleText = this.menuToggle.querySelector('.in-page-nav--menu--toggle-text');
        this.menuContent = this.menu.querySelector('.in-page-nav--menu--content');
        this.menuContentItems = [];
        let findMenuContentItems = this.menuContent.querySelectorAll('ol li a');
        findMenuContentItems.forEach(f => this.menuContentItems.push(f));
        this.contentWrapper = el.querySelector('.in-page-nav--content');
        this.contentSections = [];
        let findContentSections = this.contentWrapper.querySelectorAll('.in-page-nav--content--section');
        findContentSections.forEach(f => this.contentSections.push(f));
        // add accessibility markup
        this.menuContent.setAttribute('id',`in-page-nav--${getIndex}--menu--content`);
        this.menuToggle.setAttribute('aria-controls',`in-page-nav--${getIndex}--menu--content`);
        // toggle button behaviour
        this.menuToggle.addEventListener('click', () => {
            if(this.menuContentExpanded) {
                // close
                this.toggleMenu(false);
            } else {
                // open
                this.toggleMenu(true);
            }
        });
        // menu link click behaviour
        this.menuContentItems.forEach(i => {
            i.addEventListener('click', (e) => {
                let targetEl = document.querySelector(i.getAttribute('href'));
                if(targetEl != null && targetEl.scrollIntoView) {
                    e.preventDefault();
                    targetEl.scrollIntoView({ behavior: "smooth" });
                }
                if(isMobile) this.toggleMenu(false);
            });
        })
        // do initial resize check
        this.resize();
        // close mobile expander if click outside
        document.body.addEventListener('click', (e) => {
            if(isMobile) this.bodyClickTouch(e.target);
        });
    }

    updateScroll() {
        let newMenuIndex = 0,
            yTopThreshold = viewport.vh / 2, // vertical center of viewport
            yBottomThreshold = viewport.vh * .9; // 90% of viewport height
        for(let x = this.contentSections.length - 1; x > 0; x = x - 1) {
            let rect = this.contentSections[x].getBoundingClientRect();
            let thisTop = rect.top,
                thisBottom = rect.bottom;
            if(thisTop < yTopThreshold || thisBottom <  yBottomThreshold) {
                newMenuIndex = x;
                break;
            }
        }
        if(this.activeMenuIndex != newMenuIndex) this.updateMenu(newMenuIndex);
    }

    toggleMenu(mode) {
        if(!mode) {
            // close
            this.menuToggle.setAttribute('aria-expanded','false');
            this.menuContent.setAttribute('aria-hidden','true');
            this.menuContentExpanded = false;
        } else {
            // open
            this.menuToggle.setAttribute('aria-expanded','true');
            this.menuContent.removeAttribute('aria-hidden');
            this.menuContentExpanded = true;
        }
    }

    updateMenu(newIndex) {
        if(newIndex != this.activeMenuIndex) {
            this.menuToggleText.innerHTML = `<span class="list-number">${newIndex + 1}.&nbsp;</span>${this.menuContentItems[newIndex].innerHTML}`;
            this.menuContentItems[this.activeMenuIndex].classList.remove('active');
            this.menuContentItems[newIndex].classList.add('active');
            this.activeMenuIndex = newIndex;
        }
    }

    resize() {
        if(isMobile) {
            this.menuToggle.setAttribute('aria-expanded','false');
            this.menuContent.setAttribute('aria-hidden','true');
        } else {
            this.menuContent.setAttribute('aria-hidden','false');
        }
    }

    bodyClickTouch(t) {
        if(isMobile && this.menuContentExpanded) {
            let inMenu = false;
            while (t != document.body) {
                if (t == this.menu) {
                    inMenu = true;
                    break
                }
                t = t.parentNode;
            }
            if (!inMenu) {
                this.toggleMenu(false);
            }
        }
    }

}

const checkResize = () => {
    let prev = isMobile;
    isMobile = window.innerWidth < breakPoint.LG;
    if(isMobile !== prev) {
        navs.forEach(n => {
            n.resize();
        });
    }
};

const checkScroll = ({ scroll, size }) => {
    if (size.changed || scroll.changed) {
        if(!scrollUpdateRequested) {
            scrollUpdateRequested = true;
            setTimeout(() => {
                navs.forEach(n => {
                    n.updateScroll();
                });
                scrollUpdateRequested = false;
            }, 200);
        }
    }
};

// export the default function to create
export function createFrom(wrappers) {

    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            navs.push(new InPageNav(node, navs.length));
        }
    });

    window.addEventListener('resize', () => {
        if(!resizeRequested) {
            resizeRequested = true;
            setTimeout(() => {
                checkResize();
                resizeRequested = false;
            }, 200);
        }
    });

    // bind the tornis 'watch' function
    watchViewport(checkScroll);
}